export const Experiments = {
  b2c_hide_sticky_bar: 'b2c_hide_sticky_bar',
};
